import * as s from "@gromia/components/theme/t.module.css";
import cx from "classnames";
import * as React from "react";
import * as spriv from "./Agent.module.css";

export function Agent(props: {
  image: React.ReactNode;
  line1: React.ReactNode;
  line3: React.ReactNode;
  line4: React.ReactNode;
}) {
  return (
    <div className={cx(spriv.container)}>
      <div className={cx(spriv.image)}>{props.image}</div>
      <div className={cx(spriv.content)}>
        <div className={cx(spriv.line1)}>{props.line1}</div>
        <div className={cx(spriv.line3, s.fontSizeSmall1)}>{props.line3}</div>
        {props.line4
          ? (
            <div className={cx(spriv.line3, s.fontSizeSmall1)}>
              REA {props.line4}
            </div>
          )
          : null}
      </div>
    </div>
  );
}
